import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzI18nService, en_US, fr_FR, ar_EG } from 'ng-zorro-antd/i18n';

export type Lang = 'fr' | 'en' | 'ar';

/**
 * -i18n- Langue de l'interface : FR (défaut) / EN / AR (-arabic-). Retenue dans le navigateur.
 * Seul l'AFFICHAGE change : rien de ce qui est envoyé au serveur n'est traduit.
 */
@Injectable({ providedIn: 'root' })
export class LanguageService {
  private static readonly KEY = 'lang';

  constructor(private translate: TranslateService, private nzI18n: NzI18nService) {
    translate.setDefaultLang('fr'); // clé absente en anglais/arabe -> texte français (jamais la clé brute)
    this.apply(this.saved()); // jamais de rechargement ici : le sens de la page est déjà posé par main.ts
  }

  get current(): Lang {
    const l = this.translate.currentLang;
    return l === 'en' || l === 'ar' ? l : 'fr';
  }

  /** -arabic- page de droite à gauche (posé par main.ts au chargement) */
  get rtl(): boolean {
    return document.documentElement.dir === 'rtl';
  }

  use(lang: Lang): void {
    // -arabic- passer de/vers l'arabe change le sens de toute la page : on enregistre puis on recharge
    if ((lang === 'ar') !== this.rtl) {
      this.save(lang);
      location.reload();
      return;
    }
    this.apply(lang);
  }

  private apply(lang: Lang): void {
    this.translate.use(lang);
    this.nzI18n.setLocale(lang === 'en' ? en_US : lang === 'ar' ? ar_EG : fr_FR); // pagination, "Aucune donnée", calendriers
    document.documentElement.lang = lang;
    this.save(lang);
  }

  private save(lang: Lang): void {
    try { localStorage.setItem(LanguageService.KEY, lang); } catch { /* navigation privée */ }
  }

  private saved(): Lang {
    try {
      const l = localStorage.getItem(LanguageService.KEY);
      return l === 'en' || l === 'ar' ? l : 'fr';
    } catch { return 'fr'; }
  }
}
